<template>
  <div class="required-info-escape m-b-lg" data-cy="required-info-escape">
    <template v-if="!showConfirm">
      <p class="font-semi m-b-xs">Can't finish this right now?</p>
      <div class="required-info-escape-option">
        <button type="button" class="btn btn-white" data-cy="graduate-wrestler-link" @click="toggleConfirm">
          <i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i> {{ profileName }} isn't wrestling with {{ teamName }} right now
        </button>
        <p class="text-gray-500 m-b-none">
          We'll stop asking for their info. Registering {{ profileName }} again brings them right back.
        </p>
      </div>
    </template>
    <div v-else class="ibox m-b-none">
      <div class="ibox-content p-t-md">
        <h3 class="m-t-none font-heavy">Is {{ profileName }} no longer wrestling with {{ teamName }}?</h3>
        <p>
          We'll mark {{ profileName }} as no longer on the team and stop asking for their info and
          memberships. If {{ profileName }} registers with {{ teamName }} again, they come right back.
          Coaches can bring them back too.
        </p>
        <p v-show="error" class="text-danger font-small">{{ errorMessage }}</p>
        <div class="required-info-escape-confirm-actions">
          <button type="button" class="btn btn-default" @click="toggleConfirm" :disabled="loading">Cancel</button>
          <ladda-button @lbClicked="graduatePressed" el-class="btn-danger" :loading="loading" data-cy="graduate-wrestler-submit">
            Yes, {{ profileName }} is no longer on the team
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';

// The bail above the required-info collector. Outside a funnel that page is a prison
// (AccessFilter redirects here until the wrestler's info is complete, and a required
// USAW/AAU card hard-blocks Next), so a family whose kid is not wrestling needs a way out
// that does not involve answering everything: graduating the wrestler. DELETE on a
// wrestler is a graduation to alumnus (see Api::V1::WrestlersController#destroy and
// WrestlerProfilePolicy#graduate?); alumni no longer gate the parent in AccessFilter, and
// a good standing registration or subscription un-graduates them
// (WrestlerProfile.restore_alumni_for_billing!), so this doubles as "not registering this
// sibling yet".
export default {
  name: 'required-info-escape',
  components: { LaddaButton },
  props: {
    wrestlerId: {
      type: Number,
      required: true,
    },
    profileName: {
      type: String,
      default: '',
    },
    teamName: {
      type: String,
      default: 'the team',
    },
    redirect: {
      type: String,
      default: '/calendar',
    },
  },
  data() {
    return {
      showConfirm: false,
      loading: false,
      error: false,
      errorMessage: 'Error, please try again later or contact support.',
    };
  },
  methods: {
    toggleConfirm() {
      this.showConfirm = !this.showConfirm;
    },
    graduatePressed: _.throttle(function () {
      const vm = this;
      if (vm.loading === true) {
        return;
      }
      vm.loading = true;
      vm.error = false;

      axios.delete(vm.$apiService.wrestlerUrl(vm.wrestlerId))
        .then(() => {
          vm.$notificationManager.emit('show-toast', `${vm.profileName} marked as no longer on the team`, true);
          window.location.assign(vm.redirect);
        })
        .catch(() => {
          vm.loading = false;
          vm.error = true;
        });
    }, 500),
  },
};
</script>
